import apiService from '../../../services/api-client';
import { PostLoginRequest, PostLoginResponse } from '../interfaces/post-login';
import {
  PostRefreshRequest,
  PostRefreshResponse,
} from '../interfaces/post-refresh';
import { PostSignUpRequest } from '../interfaces/post-sign-up';

export const authApiService = {
  async postLogin(body: PostLoginRequest) {
    const { data } = await apiService().post<PostLoginResponse>(
      `session`,
      body
    );
    return data;
  },
  async postSignUp(body: PostSignUpRequest) {
    const { data } = await apiService().post<PostLoginResponse>(
      `auth/signup`,
      body
    );
    return data;
  },
  async postRefresh(body: PostRefreshRequest) {
    const { data } = await apiService().post<PostRefreshResponse>(
      `session/refresh`,
      body
    );
    return data;
  },
};
